<template>
  <div class="widget-item table" :id="widget.object.wid" :style="style">
    <TableViewer :settings="widget.object.table" :height="widget.position.heightPixels" />
  </div>
</template>

<script>
  import TableViewer from '@/components/tableApp/TableViewer.vue';

  import templateWidget from '@/components/widgets/templates/mixins/templateWidget';
  import { simpleTypeMixin } from '@/helpers';
  import { getRBGAColor } from '@/helpers/utils';

  export default {
    name: 'TableWidget',

    components: { TableViewer },

    mixins: [simpleTypeMixin, templateWidget],

    props: {
      widget: {
        type: Object,
        required: true,
      },
    },

    computed: {
      style() {
        const baseStyle = this.defaultStyling(this.widget);
        const bgColor = getRBGAColor(
          this.widget.object.backgroundColor,
          this.widget.object.opacity / 100,
        );

        return Object.assign({}, baseStyle, {
          overflow: 'hidden',
          backgroundColor: bgColor,
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .widget-item {
    position: absolute;
    overflow: hidden;
  }

  .table-container {
    overflow: hidden;
    display: flex;
    flex-direction: column;
    text-align: center;
    width: 100%;
    height: 100%;
  }
</style>
